<template>
    <img
        alt="MVE"
        class="h-20"
        src="/assets/logo.webp"
        width=""
        height=""
    />
</template>
